// components/TrustedByBusinesses.tsx
import { Box, Container, Heading, HStack, Image, Text } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

import AdwaMaisonLogo from './TrustedByLogos/AdwaMaison.jpeg';
import NgilandiAgencies from './TrustedByLogos/NgilandiAgenciesLogo.png';
import ChiringaPrints from './TrustedByLogos/ChiringaPrints.png';
import GadgetNetLogo from './TrustedByLogos/GadgetNetLogo.png';
// import QuasarEngineeringLogo from './TrustedByLogos/GadgetNetLogo.png'
// import VitalityFoodsLogo from './TrustedByLogos/GadgetNetLogo.png'
import ExecutiveCenterLearningInstituteLogo from './TrustedByLogos/ExecutiveLogo.jpg';
// import PearsonTechnologiesLogo from './TrustedByLogos/GadgetNetLogo.png'
import GenessisPrintWorksLogo from './TrustedByLogos/GenessisPrintWorksLogo.jpeg';

const logos = [
  { src: GadgetNetLogo, alt: 'Gadget Net Africa' },
  { src: AdwaMaisonLogo, alt: 'Adwa Maison' },
  { src: NgilandiAgencies, alt: 'Ngilande Agencies' },
  { src: ChiringaPrints, alt: 'Chiringa Prints' },
  // { src: QuasarEngineeringLogo, alt: 'Quasar Engineering' },
  // { src: VitalityFoodsLogo, alt: 'Vitality Foods' },
  {
    src: ExecutiveCenterLearningInstituteLogo,
    alt: 'Executive Center Learning Institute',
  },
  // { src: PearsonTechnologiesLogo, alt: 'Pearson Technologies' },
  { src: GenessisPrintWorksLogo, alt: 'GenessisPrintWorksLogo' },
];

const TrustedByBusinesses = () => {
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const slider = sliderRef.current;
    let animationFrame: number;

    const scrollLogos = () => {
      if (slider) {
        slider.scrollLeft += 1;
        if (slider.scrollLeft >= slider.scrollWidth / 2) {
          slider.scrollLeft = 0;
        }
      }
      animationFrame = requestAnimationFrame(scrollLogos);
    };

    animationFrame = requestAnimationFrame(scrollLogos);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <Box bg="gray.50" pb={10}>
      <Container maxW="6xl">
        <Heading size="lg" textAlign="center" mb={4} mt={4} color="gray.700">
          Trusted by Businesses Across Africa
        </Heading>
        <Text textAlign="center" color="gray.600" mb={8}>
          Sale Radius powers fast-growing businesses with automation and
          customer intelligence.
        </Text>

        <Box
          ref={sliderRef}
          overflow="hidden"
          whiteSpace="nowrap"
          position="relative"
          w="100%"
        >
          <HStack spacing={12} minW="max-content" display="inline-flex" px={4}>
            {[...logos, ...logos].map((logo, index) => (
              <Image
                key={index}
                src={logo.src}
                alt={logo.alt}
                h={10}
                objectFit="contain"
                // filter="grayscale(100%)"
                _hover={{ filter: 'none' }}
                transition="filter 0.3s"
              />
            ))}
          </HStack>
        </Box>
      </Container>
    </Box>
  );
};

export default TrustedByBusinesses;
